<template>
<div
  v-if="
    claims && claims.profiles && claims.profiles['ROLE_ADMINISTRATOR'] ||
    claims && claims.custom && claims.custom['WEBCALL_PERMISSION'] ||
    claims && claims.custom && claims.custom['THIRDPARTY_WEBCALL_PERMISSION']
  "
  :class="[
      { 'call_car_contaner_min': miniDrawer },
      { 'call_car_contaner': !miniDrawer}
    ]">
  <div
    class="main_menu__engrega">
    <v-btn
      v-if="
        claims && claims.profiles && claims.profiles['ROLE_ADMINISTRATOR'] ||
        claims && claims.custom && claims.custom['WEBCALL_PERMISSION'] ||
        claims && claims.custom && claims.custom['THIRDPARTY_WEBCALL_PERMISSION']
      "
      :to="{ name: 'EntregaCall' }"
      class="main_menu__call_engrega"
    >
      <img src="@/assets/icons/icn_entrega_call.svg" alt="" class="enu__call_car_img">
      <span class="main-menu__call-car--text" v-show="!miniDrawer">Serviço de entrega</span>
      <v-icon v-show="!miniDrawer">keyboard_arrow_right</v-icon>
    </v-btn>
    <div class="engrega-hr">
      <span></span>
    </div>
    <v-btn
      v-if="
        claims && claims.profiles && claims.profiles['ROLE_ADMINISTRATOR'] ||
        claims && claims.custom && claims.custom['WEBCALL_PERMISSION'] ||
        claims && claims.custom && claims.custom['THIRDPARTY_WEBCALL_PERMISSION']
      "
      :to="{ name: 'EntregaOrders' }"
      class="main_menu__call_engrega"
    >
      <img src="@/assets/icons/icn_entrega_orders.svg" alt="" class="enu__call_car_img">
      <span class="main-menu__call-car--text" v-show="!miniDrawer">Pedidos de entrega</span>
      <v-icon v-show="!miniDrawer">keyboard_arrow_right</v-icon>
    </v-btn>
  </div>
  <div class="main_menu__empress">
    <v-btn
      @click="webcallClick()"
      v-if="
        claims && claims.profiles && claims.profiles['ROLE_ADMINISTRATOR'] ||
        claims && claims.custom && claims.custom['WEBCALL_PERMISSION'] ||
        claims && claims.custom && claims.custom['THIRDPARTY_WEBCALL_PERMISSION']
      "
      :to="{ name: 'WebCall' }"
      class="main_menu__call_car"
    >
      <img src="@/assets/icons/icn_web_call.svg" alt="" class="enu__call_car_img">
      <span class="main-menu__call-car--text" v-show="!miniDrawer">{{ $t(`${namespace}.callCar`) }}</span>
      <v-icon v-show="!miniDrawer">keyboard_arrow_right</v-icon>
    </v-btn>
  </div>
</div>
</template>

<script>
import { mapState } from 'vuex'
import commonService from '@/services/common'
import { Omega, OmegaEventIds, OmegaBusiness, OmegaStatus } from 'common/omega'
import {
  SESSION_HEADERS
} from 'utils/constants'

export default {
  name: 'WebCallButton',
  props: {
    miniDrawer: {
      type: Boolean
    },
    title: String
  },
  mounted () {},
  computed: {
    ...mapState({
      claims: ({ userClaims }) => userClaims.claims,
      user: state => state.session.user.business,
      isAdmin: ({ session }) => session.user.business.isAdministrator
    })
  },
  data () {
    return {
      namespace: 'Components.MainMenu',
      show_entrega: false /** 这个函数逻辑已经下线 */
    }
  },
  methods: {
    webcallClick () {
      try {
        // 点击webcall菜单按钮，进入webcall页面
        Omega.trackBusiness(
          OmegaEventIds.tech_b2bv3_webcall,
          {
            business: OmegaBusiness.webcall,
            type: 'all',
            status: OmegaStatus.en
          }
        )
      } catch (e) {
        console.log('omega上报错误', e)
      }
    },
    /** getWihteList这个函数逻辑已经下线 */
    getWihteList () {
      const commonparams = {
        lang: 'pt-BR',
        locale: 'pt_BR',
        location_country: 'BR'
      }
      commonService.getEntregaWihteList({
        headers: {
          authorization: this.getAuthorization(),
          'didi-header-hint-content': JSON.stringify(commonparams)
        }
      }).then(res => {
        const wihteList = (res && res.data && res.data.data && res.data.data.EntryWhiteList) ? res.data.data.EntryWhiteList : []
        const _userUUid = this.user.legacyUserId
        this.show_entrega = !!(wihteList.includes('all') || wihteList.includes(String(_userUUid)))
      })
    },
    getAuthorization () {
      const sessionStr = localStorage.getItem(SESSION_HEADERS)
      const sessionObj = sessionStr ? JSON.parse(sessionStr) : {}
      return sessionObj.authorization
    }
  }
}
</script>

<style lang="scss">
.call_car_contaner {
  width: 100%;
  display: flex;
  align-items: center;
  flex-direction: column;
  .main_menu__empress {
    margin-top: 10px;
    width: 80%;
    overflow: hidden;
    border-radius: 12px;
    background-color: #535353 !important;
    padding: 5px;
    height: 52px;
    .main_menu__call_car {
      width: 100%;
      height: 100%;
      background-color: #535353 !important;
      border-radius: 12px;
      padding: 0px !important;
      margin: 0px !important;
      font-weight: 400 !important;
      &.v-btn{
        font-weight: 400 !important;
        box-shadow: none !important;
      }
    }
    .v-btn__content{
      justify-content: space-between !important;
    }
    .main-menu__call-car--text{
      overflow: hidden
    }
  }
  /* 闪送**/
  .main_menu__engrega {
    width: 80%;
    height: 100px;
    overflow: hidden;
    border-radius: 12px;
    background-color: #535353 !important;
    padding: 5px;
    .main_menu__call_engrega {
      width: 100%;
      height: 40px;
      background-color: #535353 !important;
      padding: 0px !important;
      margin: 0px !important;
      border-radius: 12px;
      border: none;
      box-shadow: none;
      font-weight: 400 !important;
      &.v-btn{
        font-weight: 400 !important;
      }
    }
    .v-btn__content{
      justify-content: space-between !important;
    }
    .main-menu__call-car--text{
      overflow: hidden
    }
    .engrega-hr{
      height: 10px;
      width: 100%;
       background: #535353;
       display: flex;
      justify-content: center;
      align-items: center;
      span{
        width: 86%;
        display: block;
        height: 1px;
        opacity: 0.2;
        background: #FFFFFF;
      }
    }
  }
  .enu__call_car_img{
    margin-right: 6px;
    width: 24px;
    height: 24px;
  }
}
.call_car_contaner_min{
  width: 100%;
  width: 55px;
  margin-left: 8px;
  .main_menu__empress {
    margin-top: 10px;
    width: 100%;
    height: 54px;
    overflow: hidden;
    border-radius: 54px;
    background-color: #535353 !important;
    padding: 6px;
    .main_menu__call_car {
      width: 100%;
      height: 100%;
      background-color: #535353 !important;
      border-radius: 43px;
      padding: 0px !important;
      margin: 0px !important;
      min-width: 10px;
      &.v-btn{
        box-shadow: none !important;
      }
    }
  }
  .main_menu__engrega {
    width: 100%;
    height: 110px;
    overflow: hidden;
    border-radius: 43px;
    background-color: #535353 !important;
    padding: 6px;
    .main_menu__call_engrega {
      width: 100%;
      height: 43px;
      background-color: #535353 !important;
      padding: 0px !important;
      margin: 0px !important;
      border-radius: 43px;
      border: none;
      box-shadow: none;
      min-width: 10px;
    }
    .engrega-hr{
      display: none;
      height: 10px;
      width: 100%;
      background: #535353;
      display: flex;
      justify-content: center;
      align-items: center;
      span{
        width: 86%;
        display: block;
        height: 1px;
        opacity: 0.2;
        background: #535353;
      }
    }
  }
  .enu__call_car_img{
    width: 24px;
    height: 24px;
  }
}
</style>
